import React from "react";
import { FaMobileAlt, FaPaintBrush, FaCogs, FaDesktop, FaShoppingCart, FaCloud } from "react-icons/fa";
// import Services from "./pages/Services"; // Iski zaroorat nahi navigation ke liye
import { useNavigate } from "react-router-dom";

export default function OurServices() {
  const navigate = useNavigate(); // ✅ Error Fix: Pehle initialize karna zaroori hai

  const services = [
    {
      title: "Web & Mobile App Development",
      bullets: ["Web Applications", "Enterprise Software", "Legacy Modernization", "API Development"],
      icon: <FaMobileAlt />,
    },
    {
      title: "UI/UX Design",
      bullets: ["Wireframes", "Prototyping", "Design Systems", "Brand Experience"],
      icon: <FaPaintBrush />,
    },
    {
      title: "Business Automation",
      bullets: ["Workflow Automation", "Dashboard Systems", "ERP Modules", "Integration Services"],
      icon: <FaCogs />,
    },
    {
      title: "Software Development",
      bullets: ["Desktop Applications", "Management Systems", "Data Handling", "Process Optimization"],
      icon: <FaDesktop />,
    },
    {
      title: "E-Commerce Solutions",
      bullets: ["Store Development", "Merchant Integrations", "Order Systems", "Secure Payments"],
      icon: <FaShoppingCart />,
    },
    {
      title: "Cloud & API Solutions",
      bullets: ["Cloud Hosting", "API Architecture", "Server Deployment", "DevOps Support"],
      icon: <FaCloud />,
    },
  ];

  const gradientText = {
    background: "linear-gradient(90deg, #00F5A0, #00CFFF)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  };

  return (
    <section className="relative py-24 px-4 sm:px-8 md:px-16 lg:px-24 bg-[#0B0E11] text-white overflow-hidden">
      {/* Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 max-w-7xl mx-auto lg:ml-24">
        {services.map((item, index) => (
          <div
            key={index}
            className="relative p-8 rounded-3xl transition-all duration-300 hover:scale-[1.03]"
            style={{
              background: "rgba(255,255,255,0.04)",
              backdropFilter: "blur(12px)",
              border: "1px solid rgba(0,245,160,0.25)",
              boxShadow: "0 0 30px rgba(0,245,160,0.15)",
            }}
          >
            {/* Icon */}
            <div className="absolute top-6 right-6 w-11 h-11 rounded-full flex items-center justify-center text-xl text-[#00F5A0] border border-[#00F5A0]/40 bg-[#0B0E11]">
              {item.icon}
            </div>

            {/* Title */}
            <h3 className="text-xl font-semibold mb-5 pr-10">
              {item.title}
            </h3>

            {/* Bullets */}
            <ul className="space-y-3 text-sm text-white/75">
              {item.bullets.map((point, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="text-[#00F5A0]">✦</span>
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Footer Text */}
      <p className="mt-16 text-center text-white/70 max-w-4xl mx-auto">
        From strategy to execution, we deliver end-to-end digital solutions designed
        to scale your business and elevate your brand.
      </p>

      <div className="mt-6 text-center">
        <button 
          onClick={() => navigate("/Services")} // ✅ Capital 'S' check karein jo aapke Route mein hai
          className="font-semibold text-[#00F5A0] hover:underline"
        >
          Explore All Services →
        </button>
      </div>
    </section>
  );
}